<!-- https://8es9hr.axshare.com/#g=1&p=%E5%84%B2%E4%BA%92%E7%A4%BE%E5%8A%A0%E9%80%80%E4%BF%9D%E7%94%B3%E8%AB%8B%E5%90%8D%E5%86%8A%E7%AE%A1%E7%90%86 -->
<!-- 儲互社加退保申請名冊管理
     儲互社加保申請通過名單管理
     儲互社加保申請不通過名單管理
     儲互社加保申請補件名單管理
     儲互社退保申請名冊管理  -->
<template>
    <div v-if="$route.meta.subListKeepAlive">
        <input style="display: none" type="file" id="uploadFile" @change="uploadFile" accept=".xlsx" />
        <div v-if="$route.query.type == 'plus'">
            <el-button type="primary" plain @click="print">列印名冊彙總表</el-button>
            <el-button type="primary" @click="openDialog('changeSendStatus')">變更送件狀態</el-button>
            <el-button type="primary" @click="openDialog('download')">下載範本</el-button>
            <el-button type="primary" @click="clickUploadBtn('postPassCheckExcel')" plain>匯入通過/不承保名單</el-button>
            <el-button type="primary" @click="clickUploadBtn('postAddDocExcel')" plain>匯入補件名單</el-button>
            <el-button
                type="primary"
                plain
                @click="(dialogImportList = true), (isactive = true)"
            >新增名冊</el-button>
        </div>
        <div v-if="$route.query.type == 'pass'">
            <el-button type="primary" @click="openDialog('changeCardSendStatus')">批次輸入保險卡寄送日期</el-button>
        </div>
        <div v-if="$route.query.type == 'fail'">
            <el-button type="primary" @click="openDialog('changeRefoundStatus')">批次更改退費狀態</el-button>
        </div>
        <div v-if="$route.query.type == 'add'">
            <el-button type="primary" @click="openDialog('changeAddDocStatus')">批次更改送件狀態</el-button>
        </div>
        <div v-if="$route.query.type == 'quit'">
            <el-button type="primary" plain @click="print">列印名冊彙總表</el-button>
            <el-button type="primary" @click="openDialog('changeSendStatus')">變更送件狀態</el-button>
            <el-button type="primary" @click="openDialog('download')">下載範本</el-button>
            <el-button type="primary" @click="clickUploadBtn('postBackCheckExcel')" plain>匯入通過/不通過名單</el-button>
            <el-button type="primary" @click="openDialog('changeRefoundStatus')">批次更改退費狀態</el-button>
        </div>
        <div v-if="$route.query.type == 'modify'">
            <el-button type="primary" plain @click="print">列印名冊彙總表</el-button>
            <el-button type="primary" @click="openDialog('changeSendStatus')">變更送件狀態</el-button>
            <el-button type="primary" @click="openDialog('download')">下載範本</el-button>
            <el-button type="primary" @click="clickUploadBtn('postModifyCheckExcel')" plain>匯入資料變更名單</el-button>
        </div>
        <workbench
            class="mt10"
            :api="api"
            :query="query"
            :columns="columns"
            :toolbar="toolbar"
            :filter="filter"
            @editData="editData"
            @addData="editData"
            @enumData="getEnumData"
            ref="list"
        >
            <template slot="button">
                <div class="mb10">
                    <div class="filter-group">
                        <span class="filter-label">儲互社</span>
                        <el-select v-model="filter.coopId" placeholder="請選擇" filterable>
                            <el-option
                                v-for="item of coop"
                                :label="item.label"
                                :value="item.value"
                                :key="item.value"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="filter-group">
                        <span class="filter-label ml10">保險年度</span>
                        <el-select v-model="filter.insEmployeeYearId" placeholder="請選擇類型">
                            <el-option
                                v-for="item of year"
                                :label="item.label"
                                :value="item.value"
                                :key="item.value"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="filter-group">
                        <span class="filter-label ml10">申請年-月</span>
                        <el-select v-model="filter.yearMonth" placeholder="請選擇類型">
                            <el-option
                                v-for="item of yearMonth"
                                :label="item.label"
                                :value="item.value"
                                :key="item.value"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="filter-group" v-if="$route.query.type == 'plus'">
                        <span class="filter-label ml10">核保狀態</span>
                        <el-select v-model="filter.underwriteStatus" placeholder="請選擇類型">
                            <el-option
                                v-for="item of underwriteStatusArr"
                                :label="item.label"
                                :value="item.value"
                                :key="item.value"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="filter-group" v-if="$route.query.type == 'pass'">
                        <span class="filter-label ml10">保險卡到件狀態</span>
                        <el-select v-model="filter.insCardSendStatus" placeholder="請選擇類型">
                            <el-option
                                v-for="item of cardStatus"
                                :label="item.label"
                                :value="item.value"
                                :key="item.value"
                            ></el-option>
                        </el-select>
                    </div>
                    <div
                        class="filter-group"
                        v-if="$route.query.type == 'fail' || $route.query.type == 'quit'"
                    >
                        <span class="filter-label ml10">退費狀態</span>
                        <el-select v-model="filter.refoundStatus" placeholder="請選擇類型">
                            <el-option
                                v-for="item of refoundStatusArr"
                                :label="item.label"
                                :value="item.value"
                                :key="item.value"
                            ></el-option>
                        </el-select>
                    </div>
                    <div class="filter-group" v-if="$route.query.type == 'add'">
                        <span class="filter-label ml10">補件狀態</span>
                        <el-select v-model="filter.needAddDoc" placeholder="請選擇類型">
                            <el-option
                                v-for="item of needAddDocArr"
                                :label="item.label"
                                :value="item.value"
                                :key="item.value"
                            ></el-option>
                        </el-select>
                    </div>
                </div>
            </template>
        </workbench>
        <el-dialog
            title="下載範本"
            :visible.sync="dialogDownload"
            :modal-append-to-body="false"
            :append-to-body="true"
        >
            <div v-if="$route.query.type != 'quit' && $route.query.type != 'modify'">
                <el-button type="primary" @click="mergeDownLoad('getPassCheckExcel')">下載通過/不承保名單範本</el-button>
                <el-button type="primary" @click="mergeDownLoad('getAddDocExcel')">下載補件名單範本</el-button>
            </div>
            <div v-if="$route.query.type == 'modify'">
                <el-button type="primary" @click="mergeDownLoad('getModifyCheckExcel')">下載資料變更匯入範本</el-button>
            </div>
            <div v-if="$route.query.type == 'quit'">
                <el-button type="primary" @click="mergeDownLoad('getBackCheckExcel')">下載退保匯入範本</el-button>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogDownload = false">關閉</el-button>
            </div>
        </el-dialog>
        <el-dialog
            :title="dialogTitle"
            :visible.sync="dialogChangeStatus"
            :modal-append-to-body="false"
            :append-to-body="true"
        >
            <el-form v-if="dialogType == 'changeSendStatus'" :model="currentEdit">
                <el-form-item label="協會送件日期">
                    <div class="date">
                        <input
                            type="text"
                            class="min_go_date genSendDate1 genSendDate"
                            placeholder="選擇日期"
                        />
                        <span class="el-input__prefix">
                            <i class="el-icon-date"></i>
                        </span>
                    </div>
                </el-form-item>
                <el-form-item label="協會送件郵局存根條碼">
                    <el-input v-model="currentEdit.genSendCode" placeholder="請輸入郵局存根條碼"></el-input>
                </el-form-item>
            </el-form>
            <el-form v-if="dialogType == 'changeCardSendStatus'" :model="currentEdit">
                <el-form-item label="保險卡狀態">
                    <el-radio-group v-model="currentEdit.insCardSendStatus">
                        <el-radio
                            v-for="(cardSend, index) in cardSendStatus"
                            :key="index"
                            :label="cardSend.value"
                        >{{ cardSend.label }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="保險卡寄送日期">
                    <div class="date">
                        <input
                            type="text"
                            class="min_go_date insCardSendDate1 insCardSendDate"
                            placeholder="選擇日期"
                        />
                        <span class="el-input__prefix">
                            <i class="el-icon-date"></i>
                        </span>
                    </div>
                </el-form-item>
            </el-form>
            <el-form v-if="dialogType == 'changeRefoundStatus'" :model="currentEdit">
                <el-form-item label="退費狀態">
                    <el-radio-group v-model="currentEdit.refoundStatus">
                        <el-radio
                            v-for="(refound, index) in refoundStatus"
                            :key="index"
                            :label="refound.value"
                        >{{ refound.label }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="退費金額">
                    <el-input v-model="currentEdit.realBackAmount"></el-input>
                </el-form-item>
            </el-form>
            <el-form v-show="dialogType == 'changeAddDocStatus'" :model="currentEdit">
                <el-form-item label="補件狀態">
                    <el-radio-group v-model="currentEdit.needAddDoc">
                        <el-radio
                            v-for="(addDoc, index) in needAddDoc"
                            :key="index"
                            :label="addDoc.value"
                        >{{ addDoc.label }}</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="補件日期">
                    <div class="date">
                        <input
                            type="text"
                            class="min_go_date addDocDate1 addDocDate"
                            placeholder="選擇日期"
                        />
                        <span class="el-input__prefix">
                            <i class="el-icon-date"></i>
                        </span>
                    </div>
                </el-form-item>
                <el-form-item label="補件說明">
                    <el-input v-model="currentEdit.addDocReason" placeholder="請輸入補件說明"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="changeSendStatus">送出</el-button>
                <el-button @click="dialogChangeStatus = false">關閉</el-button>
            </div>
        </el-dialog>
        <el-dialog
            title="名冊 匯入"
            :visible.sync="dialogImportList"
            :modal-append-to-body="false"
            :append-to-body="true"
        >
            <el-form :model="currentEdit" label-position="top">
                <!-- <el-form-item label="請輸入備註">
                    <el-input type="textarea"
                              :rows="4"
                              v-model="remark"></el-input>
                </el-form-item>-->
                <el-button type="primary" @click="downloadSample" plain>範本下載</el-button>
                <el-button class="mt10" type="primary" @click="clickUploadBtnList" plain>上傳</el-button>
                <span style="font-size: 14px" class="ml-2" v-if="file">
                    {{
                    file.name
                    }}
                </span>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="(dialogImportList = false), (isactive = false)">取消</el-button>
                <el-button type="primary" @click="addList(file)">確定</el-button>
            </div>
        </el-dialog>
        <input
            id="uploadFileList"
            type="file"
            style="display: none"
            v-if="isactive"
            @change="uploadList"
            accept=".xlsx"
        />
    </div>
    <router-view v-else></router-view>
</template>
<script>
import Workbench from "@/components/Workbench";
import { API } from "@/assets/config";
export default {
    name: "Employee_coopplusroster",
    components: { Workbench },
    data() {
        return {
            firstEnum: true,
            filter: {
                insEmployeeYearId: undefined
            },
            coopType: "",
            selectYear: "",
            needAddDoc: {},
            refoundStatus: {},
            cardSendStatus: {},
            dialogTitle: "",
            currentEdit: {},
            dialogDownload: false,
            dialogImportList: false,
            dialogChangeStatus: false,
            dialogType: "",
            query: {
                insEmployeeMainCode: "",
                action: ""
            },
            api: "",
            file: null,
            isactive: true,
            toolbar: {
                // addable: false,
            },
            coop: [],
            year: [],
            yearMonth: [],
            underwriteStatusArr: [],
            refoundStatusArr: [],
            cardStatus: [],
            needAddDocArr: [],
            columns: [
                {
                    label: "社號",
                    prop: "coopCode",
                    renderFunction(h, scope) {
                        return h(
                            "div",
                            scope.row.coopCode == "0" ? "" : scope.row.coopCode
                        );
                    }
                },
                {
                    label: "社名",
                    prop: "coopName"
                },

                {
                    label: "社員帳號",
                    prop: "memberAccount"
                },
                {
                    label: "社員姓名",
                    prop: "name"
                },
                {
                    label: "年度",
                    prop: "insEmployeeYearId",
                    renderFunction(h, scope, enumData) {
                        let year = "";
                        enumData.insEmployeeYear.forEach(item => {
                            if (item.id == scope.row.insEmployeeYearId) {
                                year = item.year - 1911;
                            }
                        });

                        return h("div", year);
                    }
                },
                {
                    label: "申請子方案",
                    prop: "subName"
                },
                {
                    label: "核保狀態",
                    prop: "underwriteStatus",
                    renderFunction(h, scope, enumData) {
                        return h(
                            "div",
                            enumData.insEmployeeUnderwriteStatus[
                                scope.row.underwriteStatus
                            ]
                        );
                    }
                },
                {
                    prop: "updateTime",
                    label: "最後修改"
                },
                {
                    prop: "updateUserName",
                    label: "最後修改人員"
                }
            ]
        };
    },
    mounted() {
        setTimeout(() => {
            this.api = "InsEmployeeMemberApply";
            this.query.insEmployeeMainCode = localStorage.getItem("codeValue");
            this.query.action = this.getApiAction(this.$route.query.type);
            if (
                this.$route.query.type == "pass" ||
                this.$route.query.type == "fail" ||
                this.$route.query.type == "add"
            ) {
                this.toolbar = {
                    addable: false
                };
            } else {
                this.toolbar = {
                    addable: true
                };
            }
        }, 500);
    },
    created() {
        this.query.action = this.getApiAction(this.$route.query.type);
    },
    watch: {
        $route(to, from) {
            // 切換不同頁面 清空search filter
            if (to.query.type !== from.query.type) {
                this.$refs.list.keyword = "";
                this.firstEnum = true;
                this.filter = {};
                this.coop = [];
                this.yearMonth = [];
                this.year = [];
            }
            if (
                to.query.type == "pass" ||
                to.query.type == "fail" ||
                to.query.type == "add"
            ) {
                this.toolbar = {
                    addable: false
                };
            } else {
                this.toolbar = {
                    addable: true
                };
            }

            this.query.action = this.getApiAction(
                to.query.type !== undefined ? to.query.type : from.query.type
            );
            this.$route.query.type =
                to.query.type !== undefined ? to.query.type : from.query.type;
            // this.$refs.list.multipleSelection = [];
        }
    },
    methods: {
        getApiAction(listType) {
            switch (listType) {
                case "plus":
                    return "getAssnAddList";
                case "pass":
                    return "getAssnPassList";
                case "fail":
                    return "getAssnFailList";
                case "add":
                    return "getAssnAddPackageList";
                case "quit":
                    return "getAssnQuitList";
                case "modify":
                    return "getAssnModifyList";
            }
        },
        getEnumData(enumData) {
            this.needAddDoc = this.renderSelection(
                enumData.insEmployeeApplyAddDocStatus
            );
            this.refoundStatus = this.renderSelection(
                enumData.insEmployeeApplyRefoundStatus
            );
            this.cardSendStatus = this.renderSelection(
                enumData.insEmployeeApplyCardSendStatus
            );
            let yearArr = [
                {
                    label: "全部"
                }
            ];
            let coopArr = [
                {
                    label: "全部"
                }
            ];
            let yearMonthArr = [
                {
                    label: "全部"
                }
            ];

            if (this.firstEnum) {
                if (enumData.insEmployeeYear.length == 0) {
                    this.year = yearArr;
                } else {
                    enumData.insEmployeeYear.map(item => {
                        yearArr.push({
                            label: item.year - 1911,
                            value: item.id
                        });
                        return (this.year = yearArr);
                    });
                    this.$set(this.filter, 'insEmployeeYearId', this.year[1].value);
                    // 觸發資料重新載入，篩選條件生效
                    this.$nextTick(() => {
                        if (this.$refs.list && this.$refs.list.getData) {
                            this.$refs.list.getData(true);
                        }
                    });
                }
                this.firstEnum = false;
            }

            if (enumData.coops.length == 0) {
                this.coop = coopArr;
            } else {
                enumData.coops.map(item => {
                    coopArr.push({
                        label: item.name,
                        value: item.id
                    });
                    return (this.coop = coopArr);
                });
            }
            if (enumData.employeeYearMonth.length == 0) {
                this.yearMonth = yearMonthArr;
            } else {
                enumData.employeeYearMonth.map(item => {
                    yearMonthArr.push({
                        value: item.yearMonthAd,
                        label: item.yearMonthRc
                    });
                    return (this.yearMonth = yearMonthArr);
                });
            }
            if (this.$route.query.type == "plus") {
                this.underwriteStatusArr = this.renderSelection(
                    enumData.insEmployeeUnderwriteStatus
                );
            } else if (this.$route.query.type == "pass") {
                this.cardStatus = this.renderSelection(
                    enumData.insEmployeeApplyCardSendStatus
                );
            } else if (this.$route.query.type == "fail") {
                this.refoundStatusArr = this.renderSelection(
                    enumData.insEmployeeApplyRefoundStatus
                );
            } else if (this.$route.query.type == "add") {
                this.needAddDocArr = this.renderSelection(
                    enumData.insEmployeeApplyAddDocStatus
                );
            }
        },
        renderSelection(enumSelection) {
            let defaultObj = [
                {
                    label: "全部"
                }
            ];
            let mergeArray = Object.keys(enumSelection).map(key => {
                return { label: enumSelection[key], value: parseInt(key) };
            });
            return defaultObj.concat(mergeArray);
        },
        clickUploadBtn(action) {
            let a = document.getElementById("uploadFile");
            a.setAttribute("data-action", action);
            a.click();
        },
        clickUploadBtnList() {
            let a = document.getElementById("uploadFileList");
            a.click();
        },
        changeSendStatus() {
            let idList = this.$refs.list.multipleSelection.map(sel => sel.id);
            const form = new FormData();

            let api = API.InsEmployeeMemberApply + `?action=${this.dialogType}`;

            //加保通過
            if (this.currentEdit.insCardSendDate !== undefined) {
                form.append(
                    "insCardSendDate",
                    this.currentEdit.insCardSendDate
                );
            }
            form.append(
                "insCardSendStatus",
                this.currentEdit.insCardSendStatus !== ""
                    ? this.currentEdit.insCardSendStatus
                    : ""
            );
            //加保不通過
            form.append("refoundStatus", this.currentEdit.refoundStatus || "");
            form.append(
                "realBackAmount",
                this.currentEdit.realBackAmount || ""
            );
            //補件
            if (this.currentEdit.addDocDate !== undefined) {
                form.append("addDocDate", this.currentEdit.addDocDate);
            }
            form.append("needAddDoc", this.currentEdit.needAddDoc || "");
            form.append("addDocReason", this.currentEdit.addDocReason || "");
            //加保申請名冊
            if (this.currentEdit.genSendDate !== undefined) {
                form.append("genSendDate", this.currentEdit.genSendDate);
            }
            form.append("genSendCode", this.currentEdit.genSendCode || "");
            form.append("idList", JSON.stringify(idList));

            let thenCB = () => {
                this.showAjaxSuccessMsg();
                this.$refs.list.getData();
                this.dialogChangeStatus = false;
                this.currentEdit = {};
            };
            this.mAxiosPost(api, form, thenCB);
        },
        uploadFile(event) {
            let action = event.srcElement.attributes["data-action"].nodeValue;
            if (event.target.files && event.target.files[0]) {
                let api = API.InsEmployeeMemberApply + `?action=${action}`;

                const form = new FormData();
                form.append("file", event.target.files[0]);
                let thenCB = () => {
                    this.showAjaxSuccessMsg();
                    this.$refs.list.getData();
                    document.getElementById("uploadFile").value = "";
                };
                this.mAxiosPost(api, form, thenCB);
            }
        },
        uploadList(event) {
            this.isactive = true;
            if (event.target.files && event.target.files[0]) {
                this.file = event.target.files[0];
            }
        },
        openDialog(dialogType) {
            let idList = this.$refs.list.multipleSelection.map(sel => sel.id);
            this.currentEdit = {};
            let objectStr = "";
            let messageStr = "";
            this.dialogType = dialogType;
            $(".min_go_date").val("");
            // changeSendStatus
            //changeCardSendStatus
            //changeRefoundStatus
            //changeAddDocStatus
            switch (dialogType) {
                case "download":
                    messageStr = "請選擇要匯出的資料";
                    objectStr = "dialogDownload";
                    break;
                case "changeSendStatus":
                    this.dialogTitle = "變更送件狀態";
                    messageStr = "請選擇要變更送件狀態的資料";
                    objectStr = "dialogChangeStatus";
                    break;
                case "changeCardSendStatus":
                    this.dialogTitle = "批次輸入保險卡寄送日期";
                    messageStr = "請選擇要批次輸入保險卡寄送日期的資料";
                    objectStr = "dialogChangeStatus";
                    break;
                case "changeRefoundStatus":
                    this.dialogTitle = "批次更改退費狀態";
                    messageStr = "請選擇要批次更改退費狀態的資料";
                    objectStr = "dialogChangeStatus";
                    break;
                case "changeAddDocStatus":
                    this.dialogTitle = "批次更改送件狀態";
                    messageStr = "請選擇要變批次更改送件狀態的資料";
                    objectStr = "dialogChangeStatus";
                    break;
            }

            if (idList.length == 0) {
                this.$message({
                    type: "error",
                    message: messageStr,
                    duration: 5000
                });
                return;
            }
            this[objectStr] = true;
            const vm = this;
            setTimeout(() => {
                $(".min_go_date").datepicker({
                    changeYear: true,
                    changeMonth: true,
                    currentText: "今天",
                    dateFormat: "Rmmdd",
                    showButtonPanel: true,
                    yearRange: "1912:c+10",
                    onSelect(data) {
                        let key = $(this)[0].className.split(" ")[2];
                        if (data) {
                            vm.currentEdit[key] =
                                parseInt(data.split("-")[0]) +
                                1911 +
                                "-" +
                                data.slice(4);
                        }
                    }
                });
            }, 1);
        },
        mergeDownLoad(action) {
            let idList = this.$refs.list.multipleSelection.map(sel => sel.id);
            if (idList.length == 0) {
                this.$message({
                    type: "error",
                    message: "請選擇要匯出的資料",
                    duration: 5000
                });
                return;
            }

            let api =
                API.InsEmployeeMemberApply +
                `?action=${action}&idList=${encodeURI(JSON.stringify(idList))}`;
            this.downLoadFile(api);
        },
        downLoadFile(url) {
            this.mDownloadFile(url);
            this.dialogDownload = false;
        },
        downloadSample() {
            const url = API.InsEmployeeMemberApply + "?action=getAddExcel";

            this.mDownloadFile(url);
        },
        print() {
            let url = "";
            let fileTitle = "";
            let type =
                this.$route.query.type == "plus"
                    ? 1
                    : this.$route.query.type == "quit"
                    ? 2
                    : 3;
            let dataArr = this.$refs.list.multipleSelection;
            if (dataArr.length <= 0) {
                this.$message({
                    type: "warning",
                    message: "尚未選擇資料",
                    duration: 5000
                });
                return;
            }
            let newArr = [];
            dataArr.map(item => {
                newArr.push(item.id);
            });
            if (
                this.$route.query.type == "plus" ||
                this.$route.query.type == "quit"
            ) {
                url =
                    API.InsEmployeeMemberApply +
                    `?action=printReport&idList=${JSON.stringify(
                        newArr
                    )}&type=${type}&insEmployeeMainCode=${
                        this.query.insEmployeeMainCode
                    }`;
                if (this.$route.query.type == "plus") {
                    fileTitle = "加保名冊彙總表";
                } else {
                    fileTitle = "退保名冊彙總表";
                }
            } else {
                url =
                    API.InsEmployeeMemberApply +
                    `?action=printReport&idList=${JSON.stringify(
                        newArr
                    )}&type=${type}&insEmployeeMainCode=${
                        this.query.insEmployeeMainCode
                    }`;
                fileTitle = "資料資料變更名冊彙總表";
            }

            this.mDownloadFile(url, true, `${fileTitle}.pdf`);
        },
        addList() {
            //新增名冊
            this.importExcel();
        },
        importExcel() {
            const url =
                API.InsEmployeeMemberApply +
                `?action=postAddExcel&insEmployeeMainCode=${localStorage.getItem(
                    "codeValue"
                )}`;

            const form = new FormData();
            const thenCB = () => {
                this.showAjaxSuccessMsg();
                this.dialogImportList = false;
            };
            form.append("file[list]", this.file);
            this.file = null;
            this.isactive = false;
            this.dialogImportList = false;
            this.mAxiosPost(url, form, thenCB);
        },
        editData(id) {
            if (id == "new") {
                this.$router.push({
                    name: "employee_coopplusroster_edit",
                    params: { subId: id },
                    query: { type: this.$route.query.type }
                });
            } else {
                this.$router.push({
                    name: "employee_coopplusroster_edit",
                    params: { subId: id },
                    query: { type: this.$route.query.type }
                });
            }
        }
    }
};
</script>